import * as angular from 'angular';

export class IssueCostsFactory {
    private apiRoot: string = '/api/v1/companies';
    private $http;

    constructor($http) {
        this.$http = $http;
    }

    get(companyId, issueId, params) {
        return this.$http.get(
            `${this.apiRoot}/${companyId}/issues/${issueId}/costs/`,
            { params }
        );
    }
}

angular
    .module('app')
    .service('IssueCostsFactory', IssueCostsFactory);



// WEBPACK FOOTER //
// ./node_modules/angularjs-template-loader??ref--0-1!./src/app/services/issue-materials.factory.ts